<template>
    <div style="overflow-x: hidden; margin-top: -50px">
        <loadScreenComponent></loadScreenComponent>
        <GanttComponent is-public :allotment-name="this.allotment?.name" v-if="this.allotment.name"></GanttComponent>
    </div>
</template>

<script>
import loadScreenComponent from '../../components/layouts/loadScreenComponent';
import GanttComponent from './GanttComponent';
import Task from '../../services/Task';
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';

export default {
    name: "PublicGanttComponent",
    components: {
        loadScreenComponent,
        GanttComponent,
    },
    async mounted() {
        localStorage.setItem('companyId', this.$route.params.companyId);
        await this.checkTokenValid();
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data(){
        return{
            allotment:{},
        }
    },
    methods:{
        async checkTokenValid()
        {
            await Task.checkLinkPublico(this.$route.params.id,this.$route.params.token).then(resp => {
                this.allotment = resp.data.allotment;
            }).catch(() => {
                this.$router.push({name:'Home'});
                this.toast.error('Link de cronograma Expirado');
            })
        }
    }
}
</script>

<style>
body.authentication {
    display: block;
    align-items: flex-start;
    justify-content: left;
    background: #eff1f5;
}
</style>

